import { LOGIN_STORE, TYPE_KEY, USER_PROFILE } from "../common/constant";
import rest from "../common/rest";
import {
  clearMessages,
  createErrorMessages,
  createBackendErrorMessages,
  createSuccessMessages,
  messagesReceived
} from "./message";
import { namesChanged } from "./login";
import { MAX_PASSWORD_CHARS, MIN_PASSWORD_CHARS } from "./userManagement";

const REDUCER = "USERPROFILE.";

// action keys
const PROPERTY_CHANGED_ACTION = REDUCER + "PROPERTY_CHANGED_ACTION";

export const PROPERTY_NAME = "propertyName";
export const PROPERTY_VALUE = "propertyValue";

// store attribute keys
export const FIRSTNAME = "firstname";
export const LASTNAME = "lastname";
export const CURRENT_PASSWORD = "currentPassword";
export const CURRENT_PASSWORD_IS_VALID = "currentPasswordIsValid";
export const NEW_PASSWORD = "newPassword";
export const NEW_PASSWORD_IS_VALID = "newPasswordIsValid";
export const NEW_PASSWORD_CONFIRM = "newPasswordConfirm";
export const NEW_PASSWORD_CONFIRM_IS_VALID = "newPasswordConfirmIsValid";
export const CHANGE_PASSWORD_DIALOG_OPEN = "changePasswordDialogOpen";

const initialState = {
  [FIRSTNAME]: undefined,
  [LASTNAME]: undefined,

  [CURRENT_PASSWORD]: undefined,
  [NEW_PASSWORD]: undefined,
  [NEW_PASSWORD_CONFIRM]: undefined,

  [CURRENT_PASSWORD_IS_VALID]: true,
  [NEW_PASSWORD_IS_VALID]: true,
  [NEW_PASSWORD_CONFIRM_IS_VALID]: false,
  [CHANGE_PASSWORD_DIALOG_OPEN]: false
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case PROPERTY_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }

  return newState;
}

export function propertyChange(propertyName, propertyValue) {
  return (dispatch, getState) => {
    const state = getState()[USER_PROFILE];
    const password = state[NEW_PASSWORD];
    const passwordConfirm = state[NEW_PASSWORD_CONFIRM];

    if (propertyName === CHANGE_PASSWORD_DIALOG_OPEN && propertyValue === true) {
      dispatch(clearMessages());
    }

    if (propertyName === NEW_PASSWORD_CONFIRM) {
      dispatch({
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: NEW_PASSWORD_CONFIRM_IS_VALID,
        [PROPERTY_VALUE]: password === propertyValue
      });
    }

    if (propertyName === NEW_PASSWORD && propertyValue !== undefined) {
      const valid =
        password !== undefined &&
        propertyValue.length >= MIN_PASSWORD_CHARS &&
        propertyValue.length <= MAX_PASSWORD_CHARS;
      dispatch({
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: NEW_PASSWORD_IS_VALID,
        [PROPERTY_VALUE]: valid
      });

      dispatch({
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: NEW_PASSWORD_CONFIRM_IS_VALID,
        [PROPERTY_VALUE]: passwordConfirm === propertyValue
      });
    }

    dispatch({
      [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
      [PROPERTY_NAME]: propertyName,
      [PROPERTY_VALUE]: propertyValue
    });
  };
}

export function loadProfile() {
  return (dispatch, getState) => {
    const state = getState()[LOGIN_STORE];

    dispatch(propertyChange(FIRSTNAME, state[FIRSTNAME]));
    dispatch(propertyChange(LASTNAME, state[LASTNAME]));
  };
}

export function saveProfile() {
  return (dispatch, getState) => {
    const state = getState()[USER_PROFILE];

    const profile = {
      [FIRSTNAME]: state[FIRSTNAME],
      [LASTNAME]: state[LASTNAME]
    };

    const payload = JSON.stringify(profile);

    rest.doPut(`/admin/users/current/profile`, payload).then(
      (json) => {
        if (json) {
          dispatch(namesChanged(state[FIRSTNAME], state[LASTNAME]));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function updatePassword() {
  return (dispatch, getState) => {
    const state = getState()[USER_PROFILE];

    const data = {
      currentPassword: state[CURRENT_PASSWORD],
      newPassword: state[NEW_PASSWORD],
      newPasswordConfirm: state[NEW_PASSWORD_CONFIRM]
    };

    const payload = JSON.stringify(data);

    rest.doPut(`/authentication/users/current/password`, payload).then(
      (json) => {
        dispatch(propertyChange(CHANGE_PASSWORD_DIALOG_OPEN, false));
        dispatch(messagesReceived(createSuccessMessages("user.profile.message.password.change.successful")));
        dispatch(propertyChange(CURRENT_PASSWORD, undefined));
        dispatch(propertyChange(NEW_PASSWORD, undefined));
        dispatch(propertyChange(NEW_PASSWORD_CONFIRM, undefined));
      },
      (request) => {
        dispatch(messagesReceived(createErrorMessages("user.profile.reponse.error." + request.response)));
      }
    );
  };
}
